import script from "./Token.vue?vue&type=script&lang=ts"
export * from "./Token.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__